import React from 'react';
import { useSelector } from 'react-redux';
import * as Reselect from 'reselect';
import { X } from 'lucide-react';

//import images (fallback defaults) — Basiq360 mark restored 2026-06-22 as a
// tactical stopgap. The Oreno-only rebrand from 404acab was bleeding into the
// sudama + oswal admin consoles which share this same web bundle. Proper fix
// (per-tenant logo from DB on the branding endpoint) is tracked for 2026-06-23.
import defaultLogoSm from "assets/images/logo/logo-sm.png";
import defaultLogoDark from "assets/images/logo/logo.png";
import defaultLogoLight from "assets/images/logo/logo.png";

import { Link } from 'react-router-dom';

import VerticalLayout from "../VerticalLayout/Index";
import withRouter from '../../components/common/withRouter';
import SimpleBar from 'simplebar-react';
import HorizontalLayout from '../HorizontalLayout';
import DepartmentFilter from '../../components/common/DepartmentFilter';
import PinnedModules from './PinnedModules';

const Sidebar = ({ layoutType, layoutSidebarSizeType }: any) => {
    const handleMobileMenu = () => {
        document.body.classList.remove("overflow-hidden");
        const sidebarOverlay = document.getElementById("sidebar-overlay");
        const appMenu = document.querySelector(".app-menu");
        
        if (sidebarOverlay) {
            sidebarOverlay.classList.add("opacity-0", "pointer-events-none");
            sidebarOverlay.classList.remove("opacity-100");
        }
        if (appMenu) {
            appMenu.classList.add("-translate-x-full", "opacity-0");
            appMenu.classList.remove("translate-x-0", "opacity-100");
        }
    };

    // Get branding from Redux Profile store
    const selectBranding = Reselect.createSelector(
        (state: any) => state.Profile,
        (profile) => profile.branding || null
    );
    const branding = useSelector(selectBranding);

    // Hostname-based tenant branding fallback. Mirrors the pattern
    // AppInitializer.tsx has been using since 2026-06-22 to let a shared
    // web build serve per-tenant logos from `/branding/<slug>/*.png` (bind-
    // mounted under `/opt/kodia/branding/<slug>/` on the VPS). Only kicks
    // in when Redux `Profile.branding` is null — so tenants that populate
    // branding via the API path (organizationBranding on login) still win.
    const tenantSlug = typeof window !== 'undefined' ? window.location.host.split('.')[0] : '';
    const isValidSlug = tenantSlug && tenantSlug !== 'localhost' && !/^\d/.test(tenantSlug);
    const tenantBase = isValidSlug ? `/branding/${tenantSlug}` : null;

    // Dynamic logo URLs with fallbacks: Redux value → tenant folder → build default.
    const logoSm = branding?.logo_sm || branding?.logo || (tenantBase ? `${tenantBase}/logo-sm.png` : defaultLogoSm);
    const logoDark = branding?.logo_dark || branding?.logo || (tenantBase ? `${tenantBase}/logo.png` : defaultLogoDark);
    const logoLight = branding?.logo_light || branding?.logo || (tenantBase ? `${tenantBase}/logo.png` : defaultLogoLight);
    const favicon = branding?.favicon || branding?.logo || (tenantBase ? `${tenantBase}/favicon.png` : defaultLogoSm);

    return (
        <React.Fragment>
            <div className={` app-menu -translate-x-full opacity-0 md:translate-x-0 md:opacity-100 w-vertical-menu bg-vertical-menu ltr:border-r rtl:border-l border-vertical-menu-border fixed bottom-0 top-0 z-[1003] transition-all duration-700 ease-[cubic-bezier(0.4,0,0.2,1)] flex flex-col group-data-[sidebar-size=md]:w-vertical-menu-md group-data-[sidebar-size=sm]:w-vertical-menu-sm group-data-[sidebar-size=sm]:pt-header group-data-[sidebar=dark]:bg-vertical-menu-dark group-data-[sidebar=dark]:border-vertical-menu-dark group-data-[sidebar=brand]:bg-vertical-menu-brand group-data-[sidebar=brand]:border-vertical-menu-brand group-data-[sidebar=modern]:bg-gradient-to-tr group-data-[sidebar=modern]:to-vertical-menu-to-modern group-data-[sidebar=modern]:from-vertical-menu-form-modern group-data-[layout=horizontal]:w-full group-data-[layout=horizontal]:bottom-auto group-data-[layout=horizontal]:top-header md:block print:hidden group-data-[sidebar-size=sm]:absolute group-data-[sidebar=modern]:border-vertical-menu-border-modern group-data-[layout=horizontal]:dark:bg-zink-700 group-data-[layout=horizontal]:border-t group-data-[layout=horizontal]:dark:border-zink-500 group-data-[layout=horizontal]:border-r-0 group-data-[sidebar=dark]:dark:bg-zink-700 group-data-[sidebar=dark]:dark:border-zink-600 group-data-[layout=horizontal]:group-data-[navbar=scroll]:absolute group-data-[layout=horizontal]:group-data-[navbar=bordered]:top-[calc(theme('spacing.header')_+_theme('spacing.4'))] group-data-[layout=horizontal]:group-data-[navbar=bordered]:inset-x-4 group-data-[layout=horizontal]:group-data-[navbar=hidden]:top-0 group-data-[layout=horizontal]:group-data-[navbar=hidden]:h-16 group-data-[layout=horizontal]:group-data-[navbar=bordered]:w-[calc(100%_-_2rem)] group-data-[layout=horizontal]:group-data-[navbar=bordered]:[&.sticky]:top-header group-data-[layout=horizontal]:group-data-[navbar=bordered]:rounded-b-md group-data-[layout=horizontal]:shadow-md group-data-[layout=horizontal]:shadow-slate-500/10 group-data-[layout=horizontal]:dark:shadow-zink-500/10 ${layoutType === "vertical" ? "group-data-[layout=horizontal]:opacity-0" : ""}`}>
                <div className="flex items-center justify-center px-5 text-center h-header group-data-[layout=horizontal]:hidden group-data-[sidebar-size=sm]:fixed group-data-[sidebar-size=sm]:top-0 group-data-[sidebar-size=sm]:bg-vertical-menu group-data-[sidebar-size=sm]:group-data-[sidebar=dark]:bg-vertical-menu-dark group-data-[sidebar-size=sm]:group-data-[sidebar=brand]:bg-vertical-menu-brand group-data-[sidebar-size=sm]:group-data-[sidebar=modern]:bg-vertical-menu-modern group-data-[sidebar-size=sm]:z-10 group-data-[sidebar-size=sm]:w-[calc(theme('spacing.vertical-menu-sm')_-_1px)] group-data-[sidebar-size=sm]:group-data-[sidebar=dark]:dark:bg-zink-700">
                    <Link to="#" className="group-data-[sidebar=dark]:hidden group-data-[sidebar=brand]:hidden group-data-[sidebar=modern]:hidden">
                        <span className="hidden group-data-[sidebar-size=sm]:block">
                            <img src={favicon} alt="" className="h-10 mx-auto" />
                        </span>
                        <span className="group-data-[sidebar-size=sm]:hidden">
                            <img src={logoDark} alt="" className="h-12 mx-auto" />
                        </span>
                    </Link>
                    <Link to="#" className="hidden group-data-[sidebar=dark]:block group-data-[sidebar=brand]:block group-data-[sidebar=modern]:block">
                        <span className="hidden group-data-[sidebar-size=sm]:block">
                            <img src={favicon} alt="" className="h-10 mx-auto" />
                        </span>
                        <span className="group-data-[sidebar-size=sm]:hidden">
                            <img src={logoLight} alt="" className="h-12 mx-auto" />
                        </span>
                    </Link>
                    <button type="button" className="hidden p-0 float-end" id="vertical-hover">
                        <i className="ri-record-circle-line"></i>
                    </button>
                    <button
                        onClick={handleMobileMenu}
                        type="button"
                        className="block md:hidden p-0 text-slate-500 hover:text-slate-600 dark:text-zink-200 dark:hover:text-zink-50 absolute right-5 top-5"
                    >
                        <X className="h-6 w-6" />
                    </button>
                </div>


                {layoutType === "vertical" ? (
                    <SimpleBar id="scrollbar" style={{ maxHeight: 'calc(100vh - var(--tb-header-height, 70px))' }} className="group-data-[sidebar-size=sm]:[&_.simplebar-content-wrapper]:!overflow-x-hidden group-data-[sidebar-size=sm]:[&_.simplebar-track.simplebar-horizontal]:!hidden">
                        <div>
                            {/* Department Filter — hidden 2026-06-20 per meeting decision.
                                Loyalty-only deployment doesn't need cross-department switching;
                                purchased_systems filter already scopes the menu. Component kept
                                imported so we can re-enable easily if multi-department returns. */}
                            {/* <DepartmentFilter /> */}

                            {/* Pinned Modules - Quick access to favorite modules */}
                            <PinnedModules />

                            <ul className="group-data-[layout=horizontal]:flex group-data-[layout=horizontal]:flex-col group-data-[layout=horizontal]:md:flex-row" id="navbar-nav">
                                <VerticalLayout />
                            </ul>
                        </div>
                    </SimpleBar>
                ) : layoutType === "horizontal" ? (
                    <div id="scrollbar" className="group-data-[layout=horizontal]:h-56 group-data-[layout=horizontal]:md:h-auto group-data-[layout=horizontal]:overflow-x-auto group-data-[layout=horizontal]:overflow-y-hidden group-data-[layout=horizontal]:max-w-screen-2xl group-data-[layout=horizontal]:mx-auto [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-slate-200 dark:[&::-webkit-scrollbar-thumb]:bg-zinc-600">
                        <div>
                            <ul className="group-data-[layout=horizontal]:flex group-data-[layout=horizontal]:flex-col group-data-[layout=horizontal]:md:flex-row" id="navbar-nav">
                                <HorizontalLayout />
                            </ul>
                        </div>
                    </div>
                ) : null}
            </div>

            <div id="sidebar-overlay" className="fixed inset-0 z-[1002] bg-slate-900/50 backdrop-blur-sm transition-all duration-700 ease-[cubic-bezier(0.4,0,0.2,1)] opacity-0 pointer-events-none"></div>
        </React.Fragment>
    );
};

export default withRouter(Sidebar);
